export default __webpack_public_path__ + "static/media/refer_an_friend.17961494.png";